export class ConstantsWebservice {
  static readonly GET_GEBKLASSE: string = '/gebklassen';
  static readonly GET_TIERKATEGORIEN: string = '/tierkategorien';
  static readonly GET_PREISSTAENDE: string = '/preisstaende';
  static readonly GET_GEBAEUDE_DATEI: string = '/gebaeude-datei';
  static readonly GET_IST_GEBAEUDE: string = '/ist-gebaeude';

  static readonly POST_GEBAEUDE_UEBERSICHT = "/gebaeude-uebersicht";
  static readonly POST_MOD_AUSP_FILTER = "/mod-ausp-filter";
  static readonly POST_KGE = "/kge";
 
}
